import type { Reference } from '@apollo/client';

import { isDevelopment } from '@constants/env';

/**
 * A paginated list field as it is held in the Apollo cache. The records
 * themselves are normalized, so `data` holds references rather than objects.
 */
export type CachedRecordList = {
  page: number;
  total: number;
  data: Reference[];
};

/**
 * Parse the args from an Apollo cache store field name
 * @param storeFieldName Apollo cache stored field name
 * @returns The args from the original query
 */
export function parseArgs<T = Record<string, unknown>>(
  storeFieldName: string
): T | undefined {
  try {
    const parsedArgs = JSON.parse(
      storeFieldName.slice(
        storeFieldName.indexOf('{'),
        storeFieldName.lastIndexOf('}') + 1
      )
    ).input as T;
    return parsedArgs;
  } catch (e) {
    if (isDevelopment) {
      // eslint-disable-next-line no-console
      console.error(`Failed to read store args for ${storeFieldName}`, e);
    }
    return undefined;
  }
}
